import React from "react";
import {Form, Input, Modal} from "antd";
import {FormModalProps} from "../../utils/useFormModal";

function DocumentsClassificationModal(props: FormModalProps) {

    const {form, ...otherProps} = props;

    return (
        <Modal {...otherProps}>
            <Form form={form} layout="vertical">
                <Form.Item label={'Name'} name={'name'} rules={[{required: true, message: 'Please input name'}]}>
                    <Input/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default DocumentsClassificationModal;
